import {
  DesignChangeMap,
  DesignChangeMapSettings,
  DesignChangeMapSettingsGlobalLoopHandling,
  DesignChangeMapSettingsIntentHandling,
  DesignCompoundIntent,
  DesignGlobalIntent,
  DesignMap,
  GenericDesignChangeItem
} from '../../../../types';
import {
  designChangeMapLabel,
  designChangeMapSettingsGlobalLoopHandlingLabels,
  designChangeMapSettingsIntentHandlingLabels,
  designChangeMapSettingsLabels
} from '../data';
import { getChangeItemObject } from './get-change-item-object';

export interface GetChangeItemLabelProps {
  key: string;
  changeItem: GenericDesignChangeItem;
  designMap: DesignMap;
}

export function getChangeItemLabel({
  key,
  changeItem,
  designMap
}: GetChangeItemLabelProps): string | null | undefined {
  const splitKey = key.split('.');
  const baseKey = splitKey[0] as keyof(DesignChangeMap);
  const changeObject = getChangeItemObject(changeItem);

  if (splitKey.length < 2) {
    return designChangeMapLabel[baseKey];
  }

  switch (baseKey) {
    case 'ccxml':
      return designChangeMapLabel.ccxml;
    case 'compoundIntents': {
      const {
        fromIntent1,
        fromIntent2,
        toIntent
      } = (changeObject as DesignCompoundIntent);
      return (
        (designMap.intents.get(fromIntent1)?.name)
        + ' + '
        + (designMap.intents.get(fromIntent2)?.name)
        + ' = '
        + (designMap.intents.get(toIntent)?.name)
      );
    }
    case 'globalIntents': {
      const { intent } = (changeObject as DesignGlobalIntent);
      return designMap.intents.get(intent)?.name;
    }
    case 'settings': {
      const settingsKey = splitKey[1] as keyof(DesignChangeMapSettings);
      switch (settingsKey) {
        case 'globalLoopHandling': {
          const key = splitKey[2] as keyof(DesignChangeMapSettingsGlobalLoopHandling);
          return designChangeMapSettingsGlobalLoopHandlingLabels[key];
        }
        case 'intentHandling': {
          const key = splitKey[2] as keyof(DesignChangeMapSettingsIntentHandling);
          return designChangeMapSettingsIntentHandlingLabels[key];
        }
        default:
          return designChangeMapSettingsLabels[settingsKey];
      }
    }
  }

  // Get the name from the changeset object.
  if (
    changeObject == null
    || typeof changeObject !== 'object'
  ) {
    return null;
  } else if (
    'name' in changeObject
    && typeof changeObject.name === 'string'
  ) {
    return changeObject.name;
  } else if (
    'props' in changeObject
    && 'config' in changeObject.props
    && 'name' in changeObject.props.config
    && typeof changeObject.props.config.name === 'string'
  ) {
    return changeObject.props.config.name;
  } else if (
    'config' in changeObject
    && typeof changeObject.config === 'string'
  ) {
    return changeObject.config;
  }

  return null;
}
